import { Modal } from '@atoms';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
interface IModalProps {
  onCancel: () => void;
  open: boolean;
}

export const TakedownImpersonation = ({ open, onCancel }: IModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title=""
      PaperProps={{
        sx: {
          maxWidth: '658px',
          borderRadius: '10px',
        },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '20px',
            color: '#464F60',
            whiteSpace: 'normal',
            marginBottom: '18px',
          }}
        >
          Takedown Impersonation
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            lineHeight: '20px',
            color: '#A3A7B0',
            whiteSpace: 'normal',
            marginBottom: '33px',
          }}
        >
          This field indicates whether the client has confirmed all their official accounts and
          granted authorization for us to proceed with takedowns of any accounts impersonating them.
        </Typography>
      </Box>
    </Modal>
  );
};
